import { cacheFirstConfig, http } from '@/core/helpers/axiosHelper';

export class GenderService {
   async getGenders() {
      return await http.get(`/genders`, cacheFirstConfig).then((response: any) => {
         return response.data;
      });
   }
}
